import config from '../config/app'
import axios from 'axios'

const PATH = '/stripe'
export default {
  payStripe (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/process-payment', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error.message)
      })
    })
  },
  payStripePayment (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/new-process-payment', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error)
      })
    })
  },
  payPurchasePayment (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/purchase-acct- payment', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error.message)
      })
    })
  },
  // createPaymentIntent (fields) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(config.server + PATH + '/create-payment-intent', fields).then((response) => {
  //       resolve(response.data)
  //     }, (error) => {
  //       reject(error.response.data.error.message)
  //     })
  //   })
  // },
  createUser (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/create-user', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error)
      })
    })
  },
  createPaymentIntent (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/create-payment-intent', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error)
      })
    })
  },
  createSetupIntent (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/create-setup-intent', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error)
      })
    })
  },
  processSuccessfulPayment (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/process-successful-payment', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error)
      })
    })
  },
  createUserPayment (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/create-user-payment', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error)
      })
    })
  },
  createSuccessfulPayment (fields) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + PATH + '/successful-payment', fields).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error)
      })
    })
  },
  getCoupons () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + PATH + '/all-coupon').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error.response.data.error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/stripe.js